<template>
    <v-container
    height="400"
    width="256"
    class="mx-auto"
    >

    <v-navigation-drawer clipped app class="background-left-panel" width="326">

      <!-- Display Logo MyGEMS -->
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-img
            src="@/assets/img/logo/Mygems logo5.png"
            width="180"
            ></v-img>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Button Menu Modul-modul Admin -->
      <v-list
      dense
      nav
      v-if="errorExist == false"
      >
        <v-list-item
        v-for="item in items"
        :key="item.title"
        link
        :to="item.url"
        :class="$route.path.toUpperCase() == item.url.toUpperCase()? 'left-panel-button' : ''"
        @click="selectTabLeftPanel(item)"
        >

          <v-badge
          v-if="item.url == '/PengurusanPengguna' && notiPengurusanPengguna != 0"
          class="pa-0 mx-0"
          color="red"
          :content="notiPengurusanPengguna"
          >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-badge>

          <v-badge
          v-else-if="item.url == '/PengurusanAduan' && notiPengurusanAduan != 0"
          class="pa-0 mx-0"
          color="red"
          :content="notiPengurusanAduan"
          >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-badge>

          <v-badge
          v-else-if="item.url == '/PengurusanPermohonanData' && notiPengurusanPermohonanData != 0"
          class="pa-0 mx-0"
          color="red"
          :content="notiPengurusanPermohonanData"
          >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-badge>

          <v-badge
          v-else-if="item.url == '/PengurusanAnalisisMakmal' && notiPengurusanAnalisisMakmal != 0"
          class="pa-0 mx-0"
          color="red"
          :content="notiPengurusanAnalisisMakmal"
          >
            <v-icon class="white--text">{{ item.icon }}</v-icon>
          </v-badge>

          <v-icon v-else class="white--text">{{ item.icon }}</v-icon>

          <v-list-item-content>
            <v-list-item-title class="white--text text-body-1">
              <span class="ml-6">{{ item.title }}</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Section Button Bottom Position -->
      <template v-slot:append>
          <v-list
          nav
          dense
          >

              <v-list-item class="blue-grey lighten-5 btn-back-home" link @click="goToPage('/ManualPengguna')">
                  <v-list-item-icon>
                  <v-icon class="icon-white primary--text">mdi-book-open</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="primary--text text-bold">Panduan Pentadbir Sistem</v-list-item-title>
              </v-list-item>

              <v-list-item class="blue-grey lighten-5 btn-back-home" link @click="backToLandingPage">
                  <v-list-item-icon>
                  <v-icon class="icon-white primary--text">mdi-home</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="primary--text text-bold">Laman Utama</v-list-item-title>
              </v-list-item>

              <v-list-item class="blue-grey lighten-5 btn-back-home" link @click="logout">
                  <v-list-item-icon>
                  <v-icon class="icon-white primary--text">mdi-logout</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title class="primary--text text-bold">Log Keluar</v-list-item-title>
              </v-list-item>

          </v-list>
      </template>

    </v-navigation-drawer>
  </v-container>
</template>

<script>
import axios from 'axios';
import { bus } from '@/main';

export default {
    data () {
      return {

        errorExist: false,

        items: [
          {
            title: "Dashboard",
            url: "/Dashboard",
            icon: "mdi-view-dashboard"
          },
          {
            title: "Pengurusan Pengguna",
            url: "/PengurusanPengguna",
            icon: "mdi-account-group"
          },
          {
            title: "Pengurusan Tetapan Pentadbir",
            url: "/PengurusanTetapanPentadbir",
            icon: "mdi-account-wrench"
          },
          {
            title: "Pengurusan Aduan Bencana",
            url: "/PengurusanAduan",
            icon: "mdi-phone-message-outline"
          },
          {
            title: "Pengurusan E-mel",
            url: "/PengurusanEmel",
            icon: "mdi-email-mark-as-unread"
          },
          {
            title: "Pengurusan Permohonan Data",
            url: "/PengurusanPermohonanData",
            icon: "mdi-folder-file-outline"
          },
          {
            title: "Pengurusan Analisis Makmal",
            url: "/PengurusanAnalisisMakmal",
            icon: "mdi-microscope"
          },
          {
            title: "Pengurusan Pemantauan Projek",
            url: "/PengurusanPemantauan",
            icon: "mdi-monitor"
          },
          {
            title: "Audit Trail",
            url: "/AuditTrail",
            icon: "mdi-post"
          },
          {
            title: "Penjanaan Laporan",
            url: "/Laporan",
            icon: "mdi-file-sign"
          },
        ],

        dataListNegeri: [],
        arrayUserBaru: [],
        arrayAduanBaru: [],
        arrayPermohonanDataBaru: [],
        arrayPermohonanAnalisisMakmalBaru: [],

      }
    },
    mounted(){
      // $store.getters.user.userdetail2.adminDescription.accessmodul[0]
      // console.log(this.$store.getters.user);
      
      this.checkingAuthority();
      this.setAccessModToButtonDisplay();
      this.getAllDropdowns();
      this.getCountNotiPengurusanPengguna();
      // this.getCountNotiPengurusanAduan();
      this.getCountNotiPengurusanPermohonanData('individu pengurus');
      this.getCountNotiPermohonanAnalisisMakmal();

    },
    methods: {


      checkingAuthority()
      {
        // console.log(this.$store.getters.user.userdetail2.adminDescription);

        if(this.$store.getters.user != ""){
          let MyDetails = this.$store.getters.user.userdetail2.adminDescription;

          if(MyDetails.jenispengguna == "Pengguna Berdaftar")
          {
            window.location.assign("https://mygems.alami.my/")
          }
        }
        else{
          window.location.assign("https://mygems.alami.my/")
        }

      },

      setAccessModToButtonDisplay(){
        
        let arrayAccessModule = this.$store.getters.user.userdetail2.adminDescription.accessmodul;
        let jenisPengguna = this.$store.getters.user.userdetail2.adminDescription.jenispengguna;
        let listItems = this.items;
        listItems.shift();
        let listDisplay = [];

        // console.log(listItems);
        // console.log(arrayAccessModule);

        if(jenisPengguna == "Pentadbir Sistem"){
          for(let i in listItems){
            listDisplay.push(listItems[i]);
          }
        }
        else{
          listItems.splice(1, 1);
          for(let i in arrayAccessModule){
            for(let x in listItems){
              if(arrayAccessModule[i] == true){
                if(x == i){
                  listDisplay.push(listItems[x]);
                }
                
              }
            }
          }
        }
        

        listDisplay.unshift({
          title: "Dashboard",
          url: "/Dashboard",
          icon: "mdi-view-dashboard"
        })

        this.items = listDisplay;

        // console.log(this.items);

      },

      getAllDropdowns(){

        this.dataListNegeri = [];
        this.dataListBencana = [];

        axios.get(this.vueUrl + 'data/alldropdowns', {
            headers: {
                'Authorization': 'Bearer ' + this.$store.getters.token,
            }
        })
        .then((response) => {          
          let data = response.data

          this.dataListNegeri = data['states'];

          this.getCountNotiPengurusanAduan();


        })
        .catch(error => {
            console.log(error);
        })

      },

      getCountNotiPengurusanPengguna(){

        this.arrayUserBaru = [];

        axios.get(this.vueUrl + 'users/all',
        {
            headers: {
                Authorization: "Bearer " + this.$store.getters.user.token,
            },
        })
        .then((response) => {
            let data = response.data;
            // console.log(data);
            let arrangeArray = [];
            for(let i in data){
              if(data[i].statuspengguna == "BARU"){
                arrangeArray.push(data[i]);
              }
            }

            // Filter table based on login as PTJ mana
            let MyRegion = this.$store.getters.user.userdetail2.adminDescription.negeri;

            if(MyRegion != ""){
              for(let i in arrangeArray){
                for(let x in arrangeArray[i].negeri.split(",")){
                  for(let z in MyRegion.split(",")){
                    if(arrangeArray[i].negeri.split(",")[x].includes(MyRegion.split(",")[z])){
                      this.arrayUserBaru.push(arrangeArray[i]);
                    }
                  }
                }
              }
            }
            else{
              this.arrayUserBaru = arrangeArray;
            }

            // console.log(this.arrayUserBaru.length);

        })
        .catch((error) => {
            // console.log(error.response);

            if(error.response.status == 401){

              bus.$emit('popupMessage',{
                  result: "error",
                  icon: "mdi-account-network-off",
                  title: "Unauthorized",
                  text: "Akaun ini tidak mendapat kebenaran untuk mengakses laman ini.",
                  nota: "jumpToLogout"
              });

            }
            else if(error.response.status == 500){

              bus.$emit('popupMessage',{
                  result: "error",
                  icon: "mdi-server-network-off",
                  title: "Internal Server Error",
                  text: "HTTP 500 Internal Server Error.",
                  nota: "jumpToLogout"
              });

            }

        });

      },

      getCountNotiPengurusanAduan(){

        let currentYear = new Date().getFullYear();
        this.arrayAduanBaru = [];

        axios.get(this.vueUrl + 'complain/all?startdate='+currentYear+'-01-01&enddate='+currentYear+'-12-31', {
            headers: {
                'Authorization': 'Bearer ' + this.$store.getters.token,
            }
        })
        .then((response) => {          
          let data = response.data

          // console.log(data);

          for(let i in data){
            for(let x in this.dataListNegeri){
              // console.log(this.dataListNegeri[x].stateid);
              if(this.dataListNegeri[x].stateid == data[i].stateid){
                data[i]["negeri"] = this.dataListNegeri[x]['statename'];
              }
            }
          }

          let tempData = [];
          for(let i in data){
            if(data[i]['statusverify'] == 'PENDING'){
              tempData.push(data[i]);
            }
          }

          // console.log(tempData);



          // Filter table based on login as PTJ mana
          let MyRegion = this.$store.getters.user.userdetail2.adminDescription.negeri;
          // console.log(MyRegion.split(","));

          // console.log(tempData);

          if(MyRegion != ""){
            
            for(let i in tempData){
              if(tempData[i].negeri != null){
                for(let x in tempData[i].negeri.split(",")){
                  for(let z in MyRegion.split(",")){
                    if(tempData[i].negeri.split(",")[x].includes(MyRegion.split(",")[z])){
                      this.arrayAduanBaru.push(tempData[i]);
                    }
                  }
                }
              }
            }
          }
          else{
            this.arrayAduanBaru = tempData;
          }

          // console.log(this.arrayAduanBaru.length);

        })
        .catch(error => {
            console.log(error);
            this.loadingTableInbox = false;
        })

      },

      getCountNotiPengurusanPermohonanData(mode){

        // console.log(mode);

        this.arrayPermohonanDataBaru = [];

        // get this year
        const d = new Date();
        let thisyear = d.getFullYear();

        //getlastyear
        const l = new Date();
        let valuedate = l.setFullYear(l.getFullYear()-1);
        let lastyear = new Date(valuedate).getFullYear();

        let urlCallDataPermohonanData = '';
        if(mode == 'individu pengurus'){
          urlCallDataPermohonanData = 'datarequest/allpermohonandataterhad?startdate='+ lastyear + '-01-01&enddate=' + thisyear + '-12-31';
        }
        else if(mode == 'pukal pengurus'){
          urlCallDataPermohonanData = 'datarequest2/allpukalpengurus?startdate='+ lastyear + '-01-01&enddate=' + thisyear + '-12-31'
        }
        else if(mode == 'individu penyunting'){
          urlCallDataPermohonanData = 'datarequest/allpermohonandataterhad2?startdate='+ lastyear + '-01-01&enddate=' + thisyear + '-12-31';
        }
        else if(mode == 'pukal penyunting'){
          urlCallDataPermohonanData = 'datarequest2/allpukalpenyunting?startdate='+ lastyear + '-01-01&enddate=' + thisyear + '-12-31';
        }

        axios.get(this.vueUrl + urlCallDataPermohonanData, {
            headers: {
                Authorization: "Bearer " + this.$store.getters.user.token,
            },
        })
        .then((response) => {
          let data = response.data;

          // console.log(data);
          if(mode == 'individu pengurus' || mode == 'pukal pengurus')
          {
            for(let i in data){
              if(data[i].status == "BARU"){
                this.arrayPermohonanDataBaru.push(data[i])
              }
            }
          }

          else if (mode == 'individu penyunting' || mode == 'pukal penyunting')
          {
            for(let i in data){
              if(data[i].status == "PERMOHONAN DITERIMA"){
                this.arrayPermohonanDataBaru.push(data[i])
              }
            }
          }
        
        })
        .catch((error) => { //eslint-disable-line
            console.log(error);
        });

      },

      getCountNotiPermohonanAnalisisMakmal(){

        this.arrayPermohonanAnalisisMakmalBaru = [];

        axios.get(this.vueUrl + 'makmal/allsemakanborangpermohonan', {
            headers: {
                Authorization: "Bearer " + this.$store.getters.user.token,
            },
        })
        .then((response) => {
          let data = response.data;

          let dataMe = this.$store.getters.user.userdetail2.adminDescription;
          let dataFilter = [];

            if(this.$store.getters.user.userdetail2.adminDescription.jenispengguna == "Pentadbir Sistem"){
                dataFilter = data;
            }
            else{
                for(let i in data){

                    if(dataMe.ptj == "BAHAGIAN PERKHIDMATAN TEKNIKAL"){
                        if(dataMe.bahagian == "BAHAGIAN PERKHIDMATAN TEKNIKAL (BPT)"){
                            if(dataMe.cawangan == "CAWANGAN PERKHIDMATAN MAKMAL"){
                                if(dataMe.unit == "UNIT MAKMAL MINERAL BERLOGAM DAN ALOI (IPOH)"){
                                    if(data[i].cawanganmakmal == "MAKMAL BPT IPOH"
                                    && data[i].jenisperkhidmatan == "ANALISIS MINERAL BERLOGAM & ALOI"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT MAKMAL MINERAL PERINDUSTRIAN (IPOH)"){
                                    if(data[i].cawanganmakmal == "MAKMAL BPT IPOH"
                                    && data[i].jenisperkhidmatan == "ANALISIS MINERAL PERINDUSTRIAN"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT MAKMAL BATUAN DAN AIR TANAH (IPOH)"){
                                    if(data[i].cawanganmakmal == "MAKMAL BPT IPOH"
                                    && data[i].jenisperkhidmatan == "ANALISIS BATUAN & AIR"){
                                        dataFilter.push(data[i])
                                    }
                                } 
                                else if(dataMe.unit == "UNIT MAKMAL EKSPLORASI GEOKIMIA (KUANTAN)"){
                                    if(data[i].cawanganmakmal == "MAKMAL GEOKIMIA KUANTAN"
                                    && data[i].jenisperkhidmatan == "ANALISIS EKSPLORASI GEOKIMIA"){
                                        dataFilter.push(data[i])
                                    }
                                } 
                            }        
                        }
                    }
                    else if(dataMe.ptj == "JMG SARAWAK"){
                        if(dataMe.bahagian == "BAHAGIAN OPERASI"){
                            if(dataMe.cawangan == "TIDAK BERKAITAN"){
                                if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - EKSPLORASI GEOKIMIA"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SARAWAK"
                                    && data[i].jenisperkhidmatan == "ANALISIS EKSPLORASI GEOKIMIA"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - MINERAL BERLOGAM DAN ALOI"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SARAWAK"
                                    && data[i].jenisperkhidmatan == "ANALISIS MINERAL BERLOGAM & ALOI"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - MINERAL PERINDUSTRIAN"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SARAWAK"
                                    && data[i].jenisperkhidmatan == "ANALISIS MINERAL PERINDUSTRIAN"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - BATUAN DAN AIR TANAH"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SARAWAK"
                                    && data[i].jenisperkhidmatan == "ANALISIS BATUAN & AIR"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - ARANG BATU"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SARAWAK"
                                    && data[i].jenisperkhidmatan == "ANALISIS BATU ARANG"){
                                        dataFilter.push(data[i])
                                    }
                                }
                            }        
                        }
                    }
                    else if(dataMe.ptj == "JMG SABAH"){
                        if(dataMe.bahagian == "BAHAGIAN OPERASI​"){
                            if(dataMe.cawangan == "TIDAK BERKAITAN"){
                                if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - EKSPLORASI GEOKIMIA"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SABAH"
                                    && data[i].jenisperkhidmatan == "ANALISIS EKSPLORASI GEOKIMIA"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - MINERAL BERLOGAM DAN ALOI"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SABAH"
                                    && data[i].jenisperkhidmatan == "ANALISIS MINERAL BERLOGAM & ALOI"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - MINERAL PERINDUSTRIAN"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SABAH"
                                    && data[i].jenisperkhidmatan == "ANALISIS MINERAL PERINDUSTRIAN"){
                                        dataFilter.push(data[i])
                                    }
                                }
                                else if(dataMe.unit == "UNIT PERKHIDMATAN MAKMAL - ARANG BATU"){
                                    if(data[i].cawanganmakmal == "MAKMAL JMG SABAH"
                                    && data[i].jenisperkhidmatan == "ANALISIS BATU ARANG"){
                                        dataFilter.push(data[i])
                                    }
                                }
                            }        
                        }
                    }
                    // else if(dataMe.ptj == "BAHAGIAN PERKHIDMATAN TEKNIKAL"){
                    //     if(dataMe.bahagian == "BAHAGIAN PERKHIDMATAN TEKNIKAL (BPT)​"){
                    //         if(dataMe.cawangan == "CAWANGAN PERKHIDMATAN MAKMAL "){
                    //             if(dataMe.unit == "UNIT MAKMAL EKSPLORASI GEOKIMIA (KUANTAN)"){
                    //                 if(data[i].cawanganmakmal == "MAKMAL GEOKIMIA KUANTAN"
                    //                 && data[i].jenisperkhidmatan == "ANALISIS EKSPLORASI GEOKIMIA"){
                    //                     dataFilter.push(data[i])
                    //                 }
                    //             }
                    //         }        
                    //     }
                    // }

                }
            }

          for(let i in dataFilter){
            if(dataFilter[i].status == "BARU"){
              this.arrayPermohonanAnalisisMakmalBaru.push(dataFilter[i])
            }
          }
        
        })
        .catch((error) => { //eslint-disable-line
            console.log(error);
        });

      },

      selectTabLeftPanel(tab){
        // if(tab.title == 'Pengurusan Permohonan Data'){

        //   bus.$emit('triggeredPengurusData', {
        //       focus: "leftPanelAdminWantToDetectCurrentModeDatatable",
        //       details: null,
        //   })

        //   // this.getCountNotiPengurusanPermohonanData('individu pengurus');

        // }
      }

    },
    computed: {
      notiPengurusanPengguna(){
        let count = this.arrayUserBaru.length
        return count;
      },
      notiPengurusanAduan(){
        let count = this.arrayAduanBaru.length
        return count;
      },
      notiPengurusanPermohonanData(){
        let count = this.arrayPermohonanDataBaru.length
        return count;
      },
      notiPengurusanAnalisisMakmal(){
        let count = this.arrayPermohonanAnalisisMakmalBaru.length
        return count;
      }
    },
    created (){
      bus.$on('triggerLeftPanelAdmin', (data) => {

        // console.log(data.focus);

        if(data != null){

          if(data.focus != undefined){

            if(data.focus == 'triggerNotiPengurusanPermohonanData'){
              let myInterval = setInterval(() => {
                  this.getCountNotiPengurusanPermohonanData(data.details);
                  clearInterval(myInterval);
              }, 500);
              
            }

            // else if(data.focus == 'triggerNotiPengurusanPermohonanDataPenyunting'){
            //   let myInterval = setInterval(() => {
            //       this.getCountNotiPengurusanPermohonanData(data.details);
            //       clearInterval(myInterval);
            //   }, 500);
              
            // }

          }
          else{
            
            if(data == null){

              this.getCountNotiPengurusanPengguna();
              this.getCountNotiPengurusanAduan();
              this.getCountNotiPengurusanPermohonanData('individu pengurus');
              // this.getCountNotiPengurusanPermohonanData('individu penyunting');
              this.getCountNotiPermohonanAnalisisMakmal();

            }
            else if(data == "error"){

              this.errorExist = true;

            }
            else if(data == "success"){

              this.errorExist = false;

            }

          }

        }
        else{

          this.getCountNotiPengurusanPengguna();
          this.getCountNotiPengurusanAduan();
          this.getCountNotiPengurusanPermohonanData('individu pengurus');
          // this.getCountNotiPengurusanPermohonanData('individu penyunting');
          this.getCountNotiPermohonanAnalisisMakmal();

        }

        

        
        
      })
    },
};
</script>

<style lang="scss">
@import '@/assets/styles/main.css';

.background-left-panel{
    background-image: url("~@/assets/img/wallpaper/left-panel1.jpg") !important;
    background-size:cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

.left-panel-button,
.left-panel-button.v-list-item--active.v-list-item.v-list-item--link.theme--dark,
.left-panel-button.v-list-item--active.v-list-item.v-list-item--link.theme--light{
  background: $primary !important;
}

.btn-back-home{
  background: #d8f5ff !important;
}

.blue-grey.lighten-5.btn-back-home:hover{
  // background-color: white !important;
  background-color: #d8f5ff !important;
}

</style>